<template>
  <NuxtLayout>
    <section class="blog__DetailHeader container">
      <h1 v-text="page.title" />
      <div v-if="page.description" class="blog__DetailHeaderLead" v-html="page.description" />
    </section>
    <div class="blog__DetailImage" v-if="page.image">
      <Flare :srcset="page.image" width="1920" :key="page.image.id" :alt="page?.title" />
    </div>

    <CMSField v-if="page?.content" :data="page.content" />
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });
  
  defineProps({
    page: {},
  });

  useHead({
    bodyAttrs: {
      class: 'blogDetail blogDetail--Landing',
    },
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_blogDetail.scss');
</style>
